export default __webpack_public_path__ + "static/media/exhibitions.a05a38d7.svg";